// theme.js
import { createTheme } from '@mui/material/styles';

const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,          // small phones
      lsm: 360,       // less small
      sm: 500,        // small phones
      md: 768,        // tablets
      mdlg: 900,      // 900px
      lg: 1050,       // small laptops 1024px
      xl: 1300,       // desktops 1280px
      xxl: 1450,      // large desktops 1440px
      
      //custom screensizes
      bp1000: 1000,   // 1000px
      bp1200: 1200,   // 1200px
      bp1500: 1500,   // 1536px
      bp1850: 1850,   // 1840px
      bp2450: 2450,
      bp2760: 2760,
      bp3720: 3720,
    },
  },
});

export default customTheme;




// Here are the default MUI Typography variant sizes in rem (from MUI v5 theme):

// | **Variant** | **Font Size (`rem`)** | **Font Weight** | **Additional Notes**       |
// | ----------- | --------------------- | --------------- | -------------------------- |
// | `h1`        | `6.0rem`              | 300             |                            |
// | `h2`        | `3.75rem`             | 300             |                            |
// | `h3`        | `3.0rem`              | 400             |                            |
// | `h4`        | `2.125rem`            | 400             |                            |
// | `h5`        | `1.5rem`              | 400             |                            |
// | `h6`        | `1.25rem`             | 500             |                            |
// | `subtitle1` | `1.0rem`              | 400             |                            |
// | `subtitle2` | `0.875rem`            | 500             |                            |
// | `body1`     | `1.0rem`              | 400             | Default for `<Typography>` |
// | `body2`     | `0.875rem`            | 400             |                            |
// | `button`    | `0.875rem`            | 500             | Uppercase by default       |
// | `caption`   | `0.75rem`             | 400             |                            |
// | `overline`  | `0.75rem`             | 400             | Uppercase by default       |
